import React from 'react';

export function SectionTitle({ children }) {
  return (
    <h3 className="text-[18px] md:text-[24px] leading-tight font-bold my-0 mb-[16px]">
      {children}
    </h3>
  );
}
